export default {
      id: "uspCard-oneCrore-usage",
      viewBox: "0 0 200 52",
      url: __webpack_public_path__ + "sprite.svg#uspCard-oneCrore",
      toString: function () {
        return this.url;
      }
    }